import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const ALLOWED_CHARACTERS_VALIDATOR_ERROR = 'invalidCharacters';

export function allowedCharacters(pattern: string): ValidatorFn {
  const regex = new RegExp(`^${pattern}$`);

  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === '') return null;
    const invalid = !regex.test(control.value);
    return invalid ? { [ALLOWED_CHARACTERS_VALIDATOR_ERROR]: true } : null;
  };
}
